import { render, staticRenderFns } from "./PerformanceGroup.vue?vue&type=template&id=3bb73026&scoped=true&"
import script from "./PerformanceGroup.vue?vue&type=script&lang=js&"
export * from "./PerformanceGroup.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceGroup.vue?vue&type=style&index=0&id=3bb73026&lang=stylus&scoped=true&"
import style1 from "./PerformanceGroup.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb73026",
  null
  
)

export default component.exports